// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/babel-polyfill/~/core-js/modules/_to-integer.js
// module id = 44
// module chunks = 0